module.exports = __webpack_public_path__ + "static/select_your_preferences_mobile-7cf798d613933c3df0827ed79bede1b5.jpg";